import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Routes, Route, useLocation } from 'react-router-dom'
import fp from 'lodash/fp'
import Pages from 'todistukset-ui/src/vtj/components/page-router/todistukset-pages.enum'
import ErrorPage from 'todistukset-ui/src/vtj/components/error-page/ErrorPage.react'
import NotFoundError from 'todistukset-ui/src/vtj/components/error-page/NotFoundError.react'
import {
  createSupportedRoutePatterns,
  getPage,
  parseComponentSelectionFromPath,
} from 'todistukset-ui/src/vtj/components/page-router/todistukset-router.util'
import PageRoutes from 'todistukset-ui/src/vtj/todistukset-page-routes.enum'
import LandingPageBanner from 'todistukset-ui/src/vtj/components/landing-page-banner/LandingPageBanner'
import {
  TodistuksetPageContentProps,
  TodistuksetRouterProps,
} from 'todistukset-ui/src/vtj/components/page-router/TodistuksetRouter.types'
import PageContent from 'todistukset-ui/src/vtj/components/page-content/PageContent.react'
import NotAuthenticatedError from 'todistukset-ui/src/vtj/components/error-page/NotAuthenticatedError.react'
import { setDocumentTitle } from 'common/src/vtj/browser/page-title'
import TabNavigation from 'todistukset-ui/src/vtj/components/tab-navigation/tab-navigation.react'
import { LanguageCode } from 'common/src/vtj/LanguageCode.enum'

export default class PageRouter extends React.Component<TodistuksetRouterProps> {
  render(): React.JSX.Element {
    const { store } = this.props
    const { lang = LanguageCode.FI } = store.common

    if (store.errors.length) {
      return <ErrorPage lang={lang} errors={store.errors.slice()} />
    }

    return (
      <Routes>
        {fp.map(
          (pattern) => (
            <Route
              key={pattern}
              path={pattern}
              element={
                <TodistuksetPageContent
                  store={store}
                  path={pattern}
                  lang={lang}
                />
              }
            />
          ),
          createSupportedRoutePatterns()
        )}
        <Route path="*" element={<NotFoundError lang={lang} />} />
      </Routes>
    )
  }
}

const TodistuksetPageContent = ({
  store,
  lang,
}: TodistuksetPageContentProps) => {
  const location = useLocation()
  const { t } = useTranslation()

  const { page, step, tab } = parseComponentSelectionFromPath(location.pathname)

  const { visiblePage, pageRoute } = getPage({ page, tab })
  const isLandingPage = visiblePage === Pages[PageRoutes.LANDING]
  const isFaqPage = visiblePage === Pages[PageRoutes.INFO]
  const isMyCertificatesPage = visiblePage === Pages[PageRoutes.MY_CERTIFICATES]
  const shouldUseLandingPageStyles =
    isLandingPage || isFaqPage || isMyCertificatesPage

  const title = visiblePage.isStep
    ? visiblePage.getTitle(t, page ?? '', step ?? '')
    : visiblePage.getTitle(lang)
  useEffect(() => {
    setDocumentTitle(title)
  }, [title])

  const isLoggedIn = !!store.common.user
  if (visiblePage.requiresAuthentication && !isLoggedIn) {
    return <NotAuthenticatedError lang={lang} />
  }

  return (
    <>
      {shouldUseLandingPageStyles ? <LandingPageBanner /> : <TabNavigation />}
      <PageContent
        visiblePage={visiblePage}
        page={pageRoute}
        step={step}
        shouldUseLandingPageStyles={shouldUseLandingPageStyles}
      />
    </>
  )
}
